import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";

// const Aux = (props) => props.children;
const Aux = ({ children, title }) => {
    return (
        <Fragment>
            <Helmet>
                <div>
                    <title>{title}</title>
                </div>
            </Helmet>
            {children}
        </Fragment>
    );
};

Aux.defaultProps = {
    title: "Welcome | CorporatePay"
};

Aux.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string
};

export default Aux;
